import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StateModule } from '@features/state/state.module';
import { TagManagerModule } from '@features/tag-manager/tag-manager.module';
import { ActionsModule } from '@fundament/actions/actions.module';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@features/forms/forms.module';
import { IconsModule } from '@features/icons/icons.module';
import { ReactiveFormsModule, FormsModule as AngularFormsModule } from '@angular/forms';
import { AddToCollectionComponent } from './add-to-collection/add-to-collection.component';
import { CollectionRoutingModule } from './collection-routing.module';
import { CreateCollectionModalModule } from './user-collection/collection-footer/create-collection-modal/create-collection-modal.module';
import { CollectionSelectComponent } from './collection-select/collection-select.component';

@NgModule({
  imports: [
    FormsModule,
    AngularFormsModule,
    IconsModule,
    CollectionRoutingModule,
    ReactiveFormsModule,
    CreateCollectionModalModule,
    ActionsModule,
    CommonModule,
    NgbModalModule,
    NgbTooltipModule,
    StateModule,
    TagManagerModule,
  ],
  declarations: [AddToCollectionComponent, CollectionSelectComponent],
  exports: [AddToCollectionComponent],
})
export class CollectionModule {}
